<template>
  <div class="borderLeft py-1 px-2" :class="!isLastChange ? 'borderBottom' : ''">
    <div class="pb-1">
      {{ field }}
    </div>
    <div class="text-xs-center vertical-center-container">
      <div class="val grey--text text--darken-1">{{ from }}</div>
      <div class="val font-weight-bold">{{ to }}</div>
    </div>
    <!-- <layout-no-padding>
      <v-flex xs12 md4>{{ field }}</v-flex>
      <v-flex xs12 md4>{{ from }}</v-flex>
      <v-flex xs12 md4>{{ to }}</v-flex>
    </layout-no-padding> -->
    <!-- <span>{{ `${field}: changed from` }}</span>
    <span class="font-weight-bold">{{ ` ${from} ` }}</span>
    <span>to</span>
    <span class="font-weight-bold">{{ ` ${to}` }}</span>-->
  </div>
</template>

<script>
export default {
  props: {
    field: String,
    from: String,
    to: String,
    isLastChange: Boolean
  },
  methods: {}
}
</script>

<style scoped>
.val {
  width: 50%;
}
.borderLeft {
  border-left: 1px solid rgba(0,0,0,0.12);
}
.borderBottom {
  border-bottom: 1px solid rgba(0,0,0,0.12);
}
</style>